import { createNamedContext } from '@utils';
import { Stripe } from './interfaces';

type NewPaymentMethodContextValue = [
  Stripe.PaymentMethod,
  React.Dispatch<React.SetStateAction<Stripe.PaymentMethod>>,
];

export const NewPaymentMethodContext = createNamedContext<NewPaymentMethodContextValue>(undefined, 'NewPaymentMethodContext');